// removed by extract-text-webpack-plugin
module.exports = {"block":"_1qmJqunVXD4JYfuyqGkCI9","content":"oJ04Ey4TlJG59ota8pnx1","text":"_3P2DjnHFenHZPbs0DMN_xN","heading":"_3u-GJGeh-x0_Cp3MjWCQUD","intro":"oSH8hat9_E5eCuRbomFp0","categories-container":"_3gnKOVSdA_DMXUoyzSEhJf","categories-list":"_3xOZAK_rw_htfiBAVgGst","category-button":"_2yiTA1TvZ2B03dvC6Mjp2a","categories-list-item":"_3q3lPUkKW6rXSfQCKUYBe1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CategoriesNavigation/CategoriesNavigation.module.scss
// module id = 739
// module chunks = 0